export default __webpack_public_path__ + "static/media/builtArtMedica.3b096ca7.png";